import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button, Table} from "elemental"
import {translate} from "translate"
import ProductQuantityGroup from "./ProductQuantityGroup"
import Price from "../Price/Price"
import _ from "lodash"
import "./ProductTable.css"

export default class ProductTable extends Component {
  static propTypes = {
    list:     PropTypes.object,
    cart:     PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }

  constructor() {
    super()
  }

  render() {
    let { list, cart, products, onChange } = this.props
    let positions                          = list || products || []
    if ( list ) positions = list.products
    let positionsActive = _.filter( positions, p => p.visible !== false )
    let rows            = _.map( positionsActive, (product, index) => {
      return (
        <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
      )
    } )

    return (
      <div className="table-scroller">
        <Table>
          <colgroup>
            <col width="5%"/>
            <col width="6%"/>
            <col width="22%"/>
            <col width="15%"/>
            <col width="10%"/>
            <col width="10%"/>
            <col width="33%"/>
          </colgroup>

          <thead>
          <tr>
            <th>Artikel</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th><strong><i className="icon-cube"></i>&nbsp;{translate( "product.deliverable" )}</strong></th>
            <th><strong>{translate( "product.price" )}</strong></th>
            <th><strong>{translate( "product.sum" )}</strong></th>
            <th><strong>{translate( "product.amount" )}</strong></th>
          </tr>
          </thead>
          <tbody>
          {rows}
          </tbody>
        </Table>
      </div>
    )
  }
}

const ProductRow = ({ product, onChange, list, cart, index }) => {
  const hasRabatt = product.pinfos && product.pinfos.zuab !== "0"
  return (
    <tr className="product-row">
      <td>
        <img height="34"
             src={product.img_src_small}
             alt=""/>
      </td>
      <td>
        <strong>{product.article_nr}</strong>
      </td>
      <td>
        <span className="product-title">{product.title}</span>
      </td>

      <td>
        {product.getNotice( "small" )}
      </td>
      <td>
        {hasRabatt && <div><Price className="black-50 f6 strike">{product.pinfos.brutto}</Price></div>}
        <Price className={`price ${hasRabatt && "red"}`}>{product.price}</Price></td>
      <td>
        {hasRabatt && <div><Price className="black-50 f6 strike">{product.pinfos.brutto * product.count * product.unit_multi}</Price></div>}
        <Price className={`price ${hasRabatt && "red"}`}>{product.price * product.count * product.unit_multi}</Price>
      </td>

      <td className="tl">
        <ProductQuantityGroup product={product} cart={cart} list={list} onChange={onChange} index={index}/>
      </td>
      <td>
        {cart ? <Button onClick={() => {
          cart.remove( product )
        }}><i className="icon-trash-empty"/></Button> : null}
      </td>
    </tr>
  )
}

ProductRow.propTypes = {
  index:    PropTypes.number,
  list:     PropTypes.object,
  cart:     PropTypes.object,
  onChange: PropTypes.func,
  product:  PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Product/ProductTable.js